import React, { useState } from "react";
import Guideline from "./Guideline";
function NewRadio(props) {
  const [answer, setAnswer] = useState(props.Answer);
  function onAnswer(event) {
    setAnswer(event.target.value);
    props.handleValue(event);
  }

  return (
    <div>
      <li id={props.id + "_li"}>
        <label className="description" htmlFor={props.id}>
          {props.QuestionText}
        </label>

        <span>
          {props.Choices.map((c) => {
            var cList = "selectButton element";
            if (answer === c) {
              cList += " answer";
            }
            return (
              <button
                id={props.id}
                type="button"
                value={c}
                key={c}
                className={cList}
                onClick={onAnswer}
              >
                {c}
              </button>
            );
          })}
        </span>
        {props.GuidelineText ? (
          <Guideline id={props.id}> {props.GuidelineText}</Guideline>
        ) : (
          <></>
        )}
      </li>
    </div>
  );
}

export default NewRadio;
